export const protocol_set = {
  Download_complete_and_detailed_mapping_file: "Descargar archivo de mapeo completo y detallado",
  Download_complete_and_simplified_mapping_file: "Descargar archivo de mapeo completo y simplificado",
  Download_filtered_and_simplified_mapping_file: "Descargar archivo de mapeo filtrado y simplificado",
  Draft_Name: "Nombre del proyecto",
  protocol_question: {
    Are_you_sure_you_want_to_delete_this_protocol_question:
      "¿Estás seguro de que quieres eliminar esta pregunta de protocolo?",
    are_you_sure_you_want_to_duplicate_this_protocol_question:
      "¿Estás seguro de que quieres duplicar esta pregunta de protocolo?",
    Basic_information: "Información básica",
    changed: "changed",
    Content: "Contenido",
    Content_is_required: "Contenido obligatorio",
    Create_protocol_question: "Crear pregunta de protocolo",
    created: "created",
    deleted: "deleted",
    erm_mapping_note: "Nota de mapeo de ERM",
    Export_to_file: "Exportar a archivo",
    Internal_audit: "Auditoría interna",
    internal_note: "Nota interna de SME",
    Link_a_requirement: "Vincular un requisito",
    link_a_protocol_question: "Vincular una pregunta de protocolo",
    link_protocol_questions: {
      Back_to_Linking_Page: "Back to the Linking Page",
      Back_to_the_Protocol_Questions_List: "Volver a la lista de preguntas del protocolo",
      Back_to_the_Requirements_List: "Volver a la lista de requisitos",
      Link_protocol_questions_to_requirements: "Vincular preguntas de protocolo a un requisito",
      Requirement_info: "Requisito",
      This_requirement_is_already_mapped_to: "Este requisito ya está asignado a:",
    },
    link_requirements: {
      Is_mapped: "Se asigna",
      Link: "Enlace",
      Name_of_the_standard: "Nombre del estándar",
      Protocol_question_is_in_edit_mode:
        "La pregunta del protocolo está en modo de edición, los cambios no se guardarán.",
      Search_results: "Resultados de la búsqueda",
      Search_similarities_in_protocol_questions: "Buscar similitudes en preguntas de protocolo",
      Select_filters: "Seleccionar filtros",
      Smart_search_mode: "Modo de búsqueda inteligente",
      You_have_to_select_at_least_one_requirement: "Debe seleccionar al menos un requisito",
    },
    Link_requirements: "Requisitos de enlace",
    linked: "vinculado",
    List_of_mapped_requirements: "Lista de requisitos mapeados",
    list_of_related_protocol_questions: "Lista de preguntas del protocolo relacionadas",
    Protocol_question: "Pregunta de protocolo",
    Protocol_question_info: "Cuestión de protocolo",
    Protocol_question_list: "Lista de preguntas del protocolo",
    reorder: {
      No_protocol_questions_found_for_this_theme_and_subtheme:
        "No se encontraron preguntas de protocolo para este tema y subtema.",
      Reorder: "Reordenar",
      Reorder_protocol_questions: "Reordenar preguntas del protocolo",
      You_need_to_select_a_theme_and_subtheme:
        "Debe seleccionar un tema y un subtema para reordenar las preguntas del protocolo.",
      You_want_to_proceed_without_saving_changes: "¿Desea continuar sin guardar? Se perderán todos los cambios.",
    },
    Requirement_will_be_unlinked_from_the_protocol_question:
      "El requisito se desvinculará de la pregunta del protocolo.",
    protocol_questions_will_be_unlinked: "Las preguntas del protocolo serán desvinculadas",
    Save_protocol_question: "Pregunta de protocolo Save",
    Scope_of_applicability: "Ámbito de aplicación",
    Scope_of_applicability_is_required: "Se requiere ámbito de aplicación",
    split: "dividir",
    Stakeholder_engagement: "Compromiso de las partes interesadas",
    Standard_structure: "Estructura estándar",
    Start_a_new_draft: "Iniciar un nuevo borrador",
    Sub_theme_is_required: "Subtema obligatorio",
    Subtheme: "Subtema",
    Theme: "Tema",
    Theme_is_required: "El tema es obligatorio",
    This_action_cannot_be_undone: "Esta acción no se puede deshacer.",
    This_file_will_contain_all_protocol_questions_in_this_mapping_set:
      "Este archivo contendrá todas las preguntas de protocolo en este conjunto de mapeo.",
    This_file_will_contain_protocol_questions_based_on_all_the_customizations_and_filters_you_have_applied:
      "Este archivo contendrá preguntas de protocolo basadas en todas las personalizaciones y filtros que haya aplicado.",
    This_mapping_draft_is_currently_in_review:
      "Este borrador de mapa está actualmente en revisión. Al realizar este cambio se cancelará el estado de revisión del borrador.",
    This_protocol_question_is_also_linked_to: "Esta pregunta sobre el protocolo también está relacionada con",
    Unlink: "Desvincular",
    unlinked: "desvinculado",
    You_will_be_redirected_to_the_newly_created_protocol_question: "Serás redirigido a la nueva pregunta de protocolo.",
  },
  Protocol_Question: "Pregunta de protocolo",
  Protocol_questions: "Preguntas del protocolo",
  Protocol_set: "Conjunto de protocolos",
  question_id: "ID de pregunta",
  related_requirements: "Requisitos relacionados",
  review_draft: {
    Approve_and_close: "Aprobar y cerrar",
    Are_you_sure_you_want_to_publish_this_draft: "¿Estás seguro de que quieres publicar este borrador?",
    at: "en",
    Created_by: "Creado por",
    Download_draft_changes: "Descargar cambios en el borrador",
    Draft_cannot_be_published_by_the_same_user:
      "El borrador no puede ser publicado por el mismo usuario que lo sometió a revisión.",
    Draft_has_already_been_submitted: "El borrador ya ha sido enviado.",
    Draft_needs_to_be_submitted_for_review_before_publishing:
      "El borrador debe ser enviado para revisión antes de publicar.",
    Draft_review: "Revisión del borrador",
    No_further_edits_will_be_possible_after_publishing:
      "No se podrán realizar más ediciones después de la publicación.",
    on: "en",
    page_description: {
      Note: "Nota: Mientras se encuentre en estado pendiente de aprobación, cualquier cambio posterior a una pregunta de protocolo en el borrador revertirá el estado pendiente de aprobación.",
      Please_press_download_draft:
        'Pulse "Descargar cambios en el borrador" para obtener una representación en Excel de los cambios en la asignación de protocolos entre este borrador y la última versión publicada.',
      The_flow_for_mapping:
        "El flujo para la asignación de cambios es el siguiente: Borrador -> Pendiente de aprobación -> Publicar.",
      This_is_the_page_for_draft:
        "Esta es la página de revisión y aprobación del borrador. Una vez aprobado por otro usuario de la herramienta cartográfica, el borrador se publicará quedando guardado sin posibilidad de realizar más cambios.",
    },
    Published_by: "Publicado por",
    Review_a_draft: "Revisar un borrador",
    Submit_for_approval: "Enviar para aprobación",
    Submitted_by: "Enviado por",
  },
  scope_of_applicability: "Ámbito de aplicabilidad",
  Search_protocol_questions: "Preguntas sobre el protocolo de búsqueda",
  Search_requirements: "Requisitos de búsqueda",
  Search_standards: "Estándares de búsqueda",
  standards: {
    Add_New_Standard: "Agregar nuevo estándar",
    All_Clients: "Todos los clientes",
    Back_to_the_Standards_List: "Volver a la lista de estándares",
    Body: "Cuerpo",
    Create_New_Standard: "Crear nuevo estándar",
    Date: "Fecha",
    Edit_Standard: "Editar estándar",
    Full_name: "Nombre completo",
    ID: "ID",
    Link: "Enlace",
    Publish_date: "Fecha de publicación",
    Save_Standard: "Guardar estándar",
    Standard_body: "Cuerpo del estándar",
    Standard_ID: "ID del estándar",
    Tenants: "Inquilinos",
    Version: "Versión",
  },
  Start_a_draft: "Iniciar un borrador",
  Start_draft_description: "Iniciar un nuevo borrador y cambiar al modo de edición",
  Starting_new_draft_process: "Inicio del proceso de nuevo borrador",
  sub_theme: "Subtema",
  theme: "Tema",
} as const;
